import React from 'react';
import { Trophy } from 'lucide-react';
import { useDailyStoplightStats } from '../../hooks/useDailyStoplightStats';

/**
 * DailyStreakChip — small header chip showing today's signed count.
 * Feb 16, 2026 — UX polish #12. Non-gamified, just gives the provider a
 * silent at-a-glance view of momentum.
 */
const DailyStreakChip = () => {
  const { signedToday, unsignedToday } = useDailyStoplightStats();
  if (signedToday === 0 && unsignedToday === 0) return null;
  const remaining = unsignedToday;
  return (
    <span
      className="hidden md:inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-emerald-500/10 border border-emerald-500/30 text-emerald-300 text-[10px] font-semibold tracking-wide"
      data-testid="daily-streak-chip"
      title={`${signedToday} signed in Genesis today${remaining > 0 ? ` · ${remaining} note${remaining !== 1 ? 's' : ''} still unsigned` : ''}`}
    >
      <Trophy className="w-3 h-3" />
      <span>{signedToday} signed today</span>
      {remaining > 0 && (
        <span className="text-amber-400">· {remaining} to go</span>
      )}
    </span>
  );
};

export default DailyStreakChip;
